export enum SecureKeypadType {
    Default = '1', //소문자/대문자/숫자
    Num = '0', //번호패드
    Qwerty = '1', //소문자/대문자/특수문자/숫자(Lower/Upper/ Special/ Number)
}
